import { render, staticRenderFns } from "./SummaryConversation.vue?vue&type=template&id=621b6ddc"
import script from "./SummaryConversation.vue?vue&type=script&lang=js"
export * from "./SummaryConversation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports